<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('credit-days')"
          prop="creditDays"
          :rules="getValidationRule('required,number')"
          class="material-style"
        >
          <el-input
            :value="form.creditDays"
            @input="form.creditDays = valueInteger($event)"
            @change="updateModelItem('creditDays', { required: true })"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('supplier-credit')"
          prop="supplierCredit"
          :rules="getValidationRule('number')"
          class="material-style"
        >
          <el-input
            :value="form.supplierCredit"
            @input="form.supplierCredit = valueNumber($event)"
            @change="updateModelItem('supplierCredit', { required: false })"
          ></el-input>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('credit-line')"
          prop="creditLine"
          :rules="getValidationRule('number')"
          class="material-style"
        >
          <el-input
            :value="form.creditLine"
            @input="form.creditLine = valueNumber($event)"
            @change="updateModelItem('creditLine', { required: true })"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('coface-credit')"
          prop="cofaceCredit"
          :rules="getValidationRule('number')"
          class="material-style"
        >
          <el-input
            :value="form.cofaceCredit"
            @input="form.cofaceCredit = valueNumber($event)"
            @change="updateModelItem('cofaceCredit', { required: true })"
          ></el-input>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          prop="currencyID"
          class="material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="updateModelItem('currencyID', { required: false })"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import mixListForm from '@/components/ListForm/mixForm'

export default {
  name: 'FormDetails',
  mixins: [mixListForm, Form],
  computed: {
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  }
}
</script>
